<template>
  <v-list class="pt-0" dense>
    <v-divider></v-divider>
    <v-list-tile @click.stop="goTo('dashboard')">
      <v-list-tile-action>
        <v-icon>dashboard</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Dashboard</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-group false prepend-icon="business">
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Estabelecimentos</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="item in partners"
        :key="item.title"
        @click.stop="goTo(item.name)"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>

    <v-list-tile
      v-for="item in visibleItems"
      :key="item.title"
      @click.stop="goTo(item.name)"
    >
      <v-list-tile-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- render conta digital if ndon't match specific id -->
    <v-list-group
      v-if="newAccount.account_id === 5283"
      false
      prepend-icon="account_balance_wallet"
      style="display: none"
    >
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Conta Digital</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="item in visibleWallet"
        :key="item.title"
        @click.stop="goTo(item.name)"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>

    <!-- else -->
    <v-list-group v-else false prepend-icon="account_balance_wallet">
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Conta Digital</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="item in visibleWallet"
        :key="item.title"
        @click.stop="goTo(item.name)"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>

    <!-- <v-list-group false prepend-icon="pix">
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Pix {{ appName }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="item in qrlist"
        :key="item.title"
        @click.stop="goTo(item.name)"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group> -->

    <v-list-group false prepend-icon="assignment_ind">
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title>Minha Conta</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="account in accounts"
        :key="account.title"
        @click.stop="goTo(account.name)"
      >
        <v-list-tile-action>
          <v-icon>{{ account.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ account.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>
  </v-list>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "SidemenuItems",
  created() {
    this.$store.dispatch("account/getAccount");
    this.$store.dispatch("system/fetchSystemConfiguration");
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      systemAppName: "system/appName",
      can: "account/can",
    }),
    appName() {
      return this.systemAppName || process.env.VUE_APP_APP_NAME || 'FlowIt';
    },
    visibleItems() {
      return this.items.filter((i) => !i.capability || this.can(i.capability));
    },
    visibleWallet() {
      return this.wallet.filter((i) => !i.capability || this.can(i.capability));
    },
  },
  watch: {
    account(newValues) {
      this.newAccount = newValues;
    },
  },
  data() {
    return {
      newAccount: {},

      items: [
        /* replacing dashboard and partners to list items below */

        // { title: "Dashboard", icon: "dashboard", name: "dashboard" },
        /* {
          title: "Estabelecimentos",
          icon: "supervisor_account",
          name: "partners",
        }, */
        { title: "Minhas vendas", icon: "payment", name: "sales", capability: "view_reports" },
        { title: "Recebíveis", icon: "local_atm", name: "receivables", capability: "view_reports" },
        { title: "Disputas", icon: "money_off", name: "chargebacks", capability: "view_reports" },
        { title: "Antecipações", icon: "list_alt", name: "anticipations", capability: "anticipations" },
        { title: "Central de Soluções", icon: "chat", name: "tickets" },
        { title: "Calculadora", icon: "exposure", name: "taxes" },
        { title: "Operadores e Perfis", icon: "group", name: "team", capability: "manage_users" },
      ],
      partners: [
        { title: "Parceiros", icon: "supervisor_account", name: "partners" },
        { title: "Pagamentos", icon: "payment", name: "partners_payments" },
      ],
      wallet: [
        { title: "Extrato", icon: "receipt", name: "wallet", capability: "view_reports" },
        { title: "QRCode", icon: "memory", name: "qrcode" },
        { title: "PagLink", icon: "link", name: "internet", capability: "paylinks" },
        { title: "Venda Digitada", icon: "keyboard", name: "manual", capability: "paylinks" },
        { title: "Pag Recorrente", icon: "repeat", name: "subscriptions", capability: "paylinks" },
        { title: "Pag Recargas", icon: "smartphone", name: "recharges", capability: "recharge" },
        { title: "Boleto Bancário", icon: "view_day", name: "boleto", capability: "paylinks" },
        { title: "Pagamento de Contas", icon: "camera_alt", name: "bill-payments", capability: "pay_bills" },
        // { title: "Depósito eletrônico", icon: "storefront", name: "eletronicPayments" },
        // { title: "Saque eletrônico", icon: "storefront", name: "eletronicReceipts" },
      ],

      // qrlist: [
      //   { title: "Transferir", icon: "move_down", name: "qrcode" },
      //   { title: "Meu Pix {{ appName }}", icon: "pix", name: "qrcode" },
      //   { title: "Pagar com QRCode", icon: "memory", name: "qrcode" },
      // ],
      calculator: [{ title: "Calculadora", icon: "exposure", name: "taxes" }],
      accounts: [
        { title: "Meus Dados", icon: "account_circle", name: "account" },
        {
          title: "Conta de Liquidação",
          icon: "attach_money",
          name: "liquidation-account",
        },
      ],
    };
  },
  methods: {
    goTo(route) {
      this.$router.push({ name: route });
    },
  },
};
</script>

<style>
.myaccount-icon {
  padding-right: 13px;
}
.liquidationaccount-icon {
  padding-right: 13px;
}
</style>
